module.exports = __webpack_public_path__ + "img/linked-in.8d27d190.png";